import { render, staticRenderFns } from "./BenifitsAdditionalInsuredWidget.vue?vue&type=template&id=ba3a21fa&scoped=true"
import script from "./BenifitsAdditionalInsuredWidget.vue?vue&type=script&lang=js"
export * from "./BenifitsAdditionalInsuredWidget.vue?vue&type=script&lang=js"
import style0 from "./BenifitsAdditionalInsuredWidget.vue?vue&type=style&index=0&id=ba3a21fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3a21fa",
  null
  
)

export default component.exports